var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowForm)?_c('worker-contract-data-form',{on:{"on-save-success":_vm.onSaveSuccess,"on-is-form-valid":_vm.onIsFormValid,"update-contract-data":_vm.updateContractData}}):_c('worker-contract-data-view')}
var staticRenderFns = []

export { render, staticRenderFns }